
          import "Radio.styles_1hwpky7.linaria.css";
          import { styled } from "@linaria/react";
import { typeStyle, focusStyle } from "@carvana/showroom-css-theme";
export const RadioWrapper = /*#__PURE__*/styled("label")({
  name: "RadioWrapper",
  class: "r1bxkz3p"
});
export const HiddenRadio = /*#__PURE__*/styled("input")({
  name: "HiddenRadio",
  class: "hujvyo9"
});
          